import { Logo } from "@/components/Logo";

export const PublicFooter = () => (
  <footer className="border-t border-zinc-200 bg-white/60 mt-auto" data-testid="public-footer">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Logo imgClassName="h-5" />
        <span>© {new Date().getFullYear()} Jobsmith. All rights reserved.</span>
      </div>
      <nav className="flex items-center gap-5 text-sm">
        <a href="/terms" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-terms">Terms</a>
        <a href="/privacy" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-privacy">Privacy</a>
        <a href="mailto:support@jobsmithai.com" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-contact">Contact</a>
      </nav>
    </div>
  </footer>
);
